import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as IconSolutionColored } from './../../../icons/SolutionColored.svg';
import styles from './EffectiveDateInfo.module.scss';
import { CoverageProduct } from 'dto/marketableProduct';
import { CustomTile } from 'individual/components/common/CustomTile';
import { useAppStore } from 'state/store';

const EffectiveDateInfo = () => {
  const { t } = useTranslation();

  const selectedCoverages = useAppStore.use.selectedCoverages();

  const isCriticalIllnessSelected = selectedCoverages.includes(
    CoverageProduct.CRITICAL_ILLNESS
  );
  const isLifeOnly =
    selectedCoverages.length === 1 &&
    selectedCoverages.includes(CoverageProduct.LIFE);
  const hasMultipleCoverages = selectedCoverages.length > 1;

  const disabilityCoverage = selectedCoverages.find(
    (cov) =>
      cov === CoverageProduct.PERMANENT_DISABILITY ||
      cov === CoverageProduct.TEMPORARY_DISABILITY
  );

  const healthInfoEffectsTextMultipleCoverages = [
    t('effectiveDateInfo.healthInfoEffects.commonIntro'),
    isCriticalIllnessSelected &&
      t('effectiveDateInfo.healthInfoEffects.compensation.criticalIllness'),
    isCriticalIllnessSelected &&
      selectedCoverages.length >= 3 &&
      t('common.and'),
    disabilityCoverage &&
      t(
        'effectiveDateInfo.healthInfoEffects.compensation.disabilityInsurances'
      ),
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <CustomTile data-testid={`effective-date-info`}>
      <IconSolutionColored
        className={styles.headingIcon}
        data-testid='icon-solution-colored'
      />
      <h2 className={styles.heading}>{t('effectiveDateInfo.title')}</h2>
      <p>{t('effectiveDateInfo.commonTextHealthDeclarationNeeded')}</p>
      <p>{t('effectiveDateInfo.commonTextDecision')}</p>
      <p>
        <Trans
          defaults={t('effectiveDateInfo.commonTextEffectiveDate')}
          components={{ bold: <strong /> }}
        />
      </p>

      {isCriticalIllnessSelected && (
        <p>
          <Trans
            defaults={t('effectiveDateInfo.criticalIllnessInfo')}
            components={{ bold: <strong /> }}
          />
        </p>
      )}

      {isLifeOnly ? (
        <p>{t('effectiveDateInfo.healthInfoEffects.onlyLife')}</p>
      ) : hasMultipleCoverages ? (
        <p>{`${healthInfoEffectsTextMultipleCoverages}.`}</p>
      ) : null}
    </CustomTile>
  );
};

export default EffectiveDateInfo;
